import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M22.38,12a2.6,2.6,0,0,1,.68-1.92A2.68,2.68,0,0,1,25,9.44a2.64,2.64,0,0,1,1.91.66A2.6,2.6,0,0,1,27.59,12a2.52,2.52,0,0,1-.68,1.86,2.61,2.61,0,0,1-1.91.68,2.65,2.65,0,0,1-1.94-.68A2.52,2.52,0,0,1,22.38,12Zm4.91,27.57H22.66V17.79h4.63Z" />
    <path d="M25,49.5A24.5,24.5,0,1,1,49.5,25,24.53,24.53,0,0,1,25,49.5Zm0-46A21.5,21.5,0,1,0,46.5,25,21.52,21.52,0,0,0,25,3.5Z" />
  </Base>
);
